import type {NpsPlot} from 'src/types/report';
import type {NpsPlotAction} from 'src/action-creators/nps-plot';
import type {RecipientResource} from 'src/types/survey';

import {
  RECEIVE_AGENCY,
  RECEIVE_WORKFLOW,
  RECEIVE_EVENT,
} from 'src/action-creators/nps-plot';


export type NpsPlotState = {
  agency: NpsPlot | null | undefined;
  agencyClient: NpsPlot | null | undefined;
  agencyConsultant: NpsPlot | null | undefined;
  workflows: {
    [workflowId: string]: NpsPlot;
  };
  events: {
    [eventId: string]: NpsPlot;
  };
};

const initialState = {
  agency: null,
  agencyClient: null,
  agencyConsultant: null,
  workflows: Object.freeze({}),
  events: Object.freeze({}),
} as const;

export default (
  state: NpsPlotState | null | undefined = initialState,
  action: NpsPlotAction,
): NpsPlotState => {
  switch (action.type) {
    case RECEIVE_AGENCY:
      if (action.recipient) {
        const updateKey = getAgencyRecipientUpdateKey(action.recipient);
        // @ts-expect-error - TS2322 - Type '{ agency?: NpsPlot | null | undefined; agencyClient?: NpsPlot | null | undefined; agencyConsultant?: NpsPlot | null | undefined; workflows?: { [workflowId: string]: NpsPlot; } | undefined; events?: { ...; } | undefined; }' is not assignable to type 'NpsPlotState'.
        return {...state, [updateKey]: action.payload};
      }
      // @ts-expect-error - TS2322 - Type '{ agency: NpsPlot; agencyClient?: NpsPlot | null | undefined; agencyConsultant?: NpsPlot | null | undefined; workflows?: { [workflowId: string]: NpsPlot; } | undefined; events?: { ...; } | undefined; }' is not assignable to type 'NpsPlotState'.
      return {...state, agency: action.payload};

    case RECEIVE_WORKFLOW:
      // @ts-expect-error - TS2322 - Type '{ workflows: { [x: string]: NpsPlot; }; agency?: NpsPlot | null | undefined; agencyClient?: NpsPlot | null | undefined; agencyConsultant?: NpsPlot | null | undefined; events?: { ...; } | undefined; }' is not assignable to type 'NpsPlotState'.
      return {
        ...state,
        workflows: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.workflows,
          [action.payload.workflowId]: action.payload.plot,
        },
      };

    case RECEIVE_EVENT:
      // @ts-expect-error - TS2322 - Type '{ events: { [x: string]: NpsPlot; }; agency?: NpsPlot | null | undefined; agencyClient?: NpsPlot | null | undefined; agencyConsultant?: NpsPlot | null | undefined; workflows?: { ...; } | undefined; }' is not assignable to type 'NpsPlotState'.
      return {
        ...state,
        events: {
          // @ts-expect-error - TS18047 - 'state' is possibly 'null'.
          ...state.events,
          [action.payload.eventId]: action.payload.plot,
        },
      };
  }

  // @ts-expect-error - TS2322 - Type 'NpsPlotState | null' is not assignable to type 'NpsPlotState'.
  return state;
};

export const getAgencyRecipientUpdateKey = (
  recipient: RecipientResource,
): string =>
  ({
    client: 'agencyClient',
    audience_member: 'agencyConsultant',
    internal: 'agencyInternal',
  }[recipient]);
